import React from 'react';
import styles from './Contact.module.css';
import { MdOutlineCall } from "react-icons/md";

function Contact({ contact }) {
  const name = contact?.name?.formatted_name;
  const phones = contact?.phones;
  return (
    <div className={`${styles.container} rcw-message-content`}>
      <div className={styles.contactnameimage} style={{ display: 'flex' }}>
        <div className={styles.contactname}>{name}</div>
      </div>
      {phones.map((phoneObj, index) => (
        <div className={styles.contactNumberContent} key={index}>
            <MdOutlineCall size={18} />
          <p className={styles.contactnumber} >
            <a href={`tel:${phoneObj.phone}`}>{phoneObj.phone}</a>
          </p>
        </div>
      ))}
    </div>
  );
}
export default Contact;
